import { gql } from '@apollo/client';
export const TEST_RULES = gql `
  query TEST_RULES($clientId: Int!, $ruleType: String!, $entityId: Int!) {
    testRules(clientId: $clientId, ruleType: $ruleType, entityId: $entityId) {
      ruleType
      entityId
      policy
      criteria
      narrative {
        value
        type
        params
      }
    }
  }
`;
export const TEST_POLICY_COVERAGE = gql `
  query TEST_POLICY_COVERAGE(
    $clientId: Int!
    $ruleType: String!
    $policyItemName: String!
    $policyItemValue: String!
  ) {
    testPolicyCoverage(
      clientId: $clientId
      ruleType: $ruleType
      policyItemName: $policyItemName
      policyItemValue: $policyItemValue
    ) {
      found
      total
      error
    }
  }
`;
export const GET_ENTITY_POLICIES = gql `
  query GET_ENTITY_POLICIES($clientId: Int!, $entityId: Int!, $ruleTypes: [String!]!) {
    getEntityPolicies(clientId: $clientId, entityId: $entityId, ruleTypes: $ruleTypes)
  }
`;
export const HAS_BUDGET_POLICY = gql `
  query HAS_BUDGET_POLICY {
    hasBudgetPolicy
  }
`;
